import React from 'react'
import { Box } from '@hub/box'
import { CoreContainer } from '@hub/core-container'
import { Stack, StackSpacer } from '@hub/stack'
import { LinkItem, OpenHamburgerMenuAtPathType, RootPathType } from '../types'
import { NavLink } from './nav-link'
import { MainNavItemWrapper } from './main-nav-item-wrapper'

interface NavLinksProps {
  primaryLinks?: LinkItem[]
  tertiaryLinks?: LinkItem[]
  tabKey: RootPathType
  label?: string
  openHamburgerMenuAtPath: OpenHamburgerMenuAtPathType
}

export const NavLinks: React.FC<NavLinksProps> = ({
  openHamburgerMenuAtPath,
  primaryLinks,
  tertiaryLinks,
  label,
}) => {
  const containerRef = React.useRef<HTMLElement>(null)

  return (
    <Box
      as={props => <nav {...props} ref={containerRef} />}
      aria-label={label}
      sx={{ height: 'size-full', position: 'relative' }}
    >
      <CoreContainer
        fadeOutOverflow={[true, true, false]}
        as={props => (
          <Stack
            {...props}
            as="ul"
            direction="row"
            gap="spacing-0"
            align="flex-start"
            shouldWrapChildren={false}
            flexGrow={0}
          />
        )}
        sx={{
          height: 'size-full',
          fontSize: 'font-sm',
          overflowX: ['scroll', null, 'hidden'],
          overflowY: 'hidden',
          position: 'relative',
        }}
      >
        <Stack
          direction="row"
          gap="spacing-0"
          align="flex-start"
          shouldWrapChildren={false}
          sx={{
            flexWrap: [null, null, 'wrap'],
            maxWidth: [null, null, 'size-full'],
            height: 'size-full',
          }}
        >
          {(primaryLinks ?? []).map((item, index) => (
            <NavLink
              key={`primary-${index}`}
              item={item}
              openHamburgerMenuAtPath={openHamburgerMenuAtPath}
              megaMenuPortalRef={containerRef}
            />
          ))}
        </Stack>
        {tertiaryLinks && tertiaryLinks.length ? (
          <StackSpacer key="spacer" as={MainNavItemWrapper} />
        ) : null}
        {(tertiaryLinks ?? []).map((item, index) => (
          <NavLink
            key={`secondary-${index}`}
            item={item}
            openHamburgerMenuAtPath={openHamburgerMenuAtPath}
            megaMenuPortalRef={containerRef}
          />
        ))}
      </CoreContainer>
    </Box>
  )
}
